(() => {
  'use strict';
  const mounted = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function mount(scope = document) {
    const roots = scope.matches?.('[data-kinora-proof]') ? [scope] : scope.querySelectorAll('[data-kinora-proof]');
    roots.forEach(root => {
      if (mounted.has(root)) return;
      const track = root.querySelector('[data-proof-track]');
      const slides = [...root.querySelectorAll('[data-proof-slide]')];
      if (!track || slides.length !== 8) return;
      const controller = new AbortController();
      const signal = controller.signal;
      let index = 0, timer = 0, visible = false, hovered = false, focused = false, disposed = false;
      const interval = Number(root.dataset.proofInterval) || 1500;
      root.dataset.proofIndex = '0';
      root.dataset.proofAdvances = '0';
      const paint = animate => {
        const step = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        track.classList.toggle('is-proof-moving', animate);
        track.style.transform = `translate3d(${-index * step}px,0,0)`;
        slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i < index || i > index + 2)));
        root.dataset.proofIndex = String(index % 5);
      };
      const stop = () => { clearTimeout(timer); timer = 0; };
      const schedule = () => {
        stop();
        if (disposed || !visible || hovered || focused || document.hidden || reduced.matches) return;
        timer = setTimeout(() => {
          index++;
          root.dataset.proofAdvances = String(Number(root.dataset.proofAdvances) + 1);
          paint(true);
          schedule();
        }, interval);
      };
      track.addEventListener('transitionend', event => {
        if (event.propertyName !== 'transform' || index < 5) return;
        index %= 5;
        paint(false);
      }, { signal });
      root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } }, { signal });
      root.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(); } }, { signal });
      root.addEventListener('focusin', () => { focused = true; stop(); }, { signal });
      root.addEventListener('focusout', () => { queueMicrotask(() => { focused = root.contains(document.activeElement); schedule(); }); }, { signal });
      document.addEventListener('visibilitychange', schedule, { signal });
      reduced.addEventListener('change', () => {
        index %= 5;
        paint(false);
        schedule();
      }, { signal });
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .05 });
        observer.observe(root);
      } else { visible = true; schedule(); }
      const resize = new ResizeObserver(() => { index %= 5; paint(false); });
      resize.observe(root);
      paint(false);
      mounted.set(root, () => { disposed = true; stop(); controller.abort(); observer?.disconnect(); resize.disconnect(); mounted.delete(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-kinora-proof]').forEach(root => mounted.get(root)?.()));
})();
